import {User, USER_LOGIN, USER_LOGIN_FAILED, USER_LOGOUT, USER_SAVE, USER_SAVE_FAILED, SUPPLIER_ID_CHANGE} from "./types";

export function userLogin(user: User) {
    return {
        type: USER_LOGIN,
        payload: user
    };
}

export function userLoginFailed(message: string) {
    return {
        type: USER_LOGIN_FAILED,
        payload: message
    };
}

export function userLogout(username: string) {
    return {
        type: USER_LOGOUT,
        meta: {
            username
        }
    };
}

export function userSave(user: User) {
    return {
        type: USER_SAVE,
        payload: user
    };
}

export function userSaveFailed(message: string) {
    return {
        type: USER_SAVE_FAILED,
        payload: message
    };
}

 export function supplierIdChange(supplierId: string) {
        return {
            type: SUPPLIER_ID_CHANGE,
            payload: supplierId
        };
}

export function supplierIdChangeFailed(message: string) {
    return {
        type: SUPPLIER_ID_CHANGE,
        payload: message
    };
}